import * as $ from "jquery";
import * as _ from "lodash";
import {BaseModuleConfigView} from "./_BaseSensorConfigView";

var moduleConfigTemplate = require('templates/settings/sensor_config/module.html');

export class ModuleConfigView extends BaseModuleConfigView {

    template = _.template(moduleConfigTemplate);

    constructor(options) {
        super(_.extend({
            events: {
                'change .settings-sensorconfig-module-node-mode': 'handleChangeModuleMode',
                'change .settings-sensorconfig-module-outdoors': 'handleChangeOutdoors'
            }
        }, options))
    }

    showInternalSensorConfig(currentNodeMode) {
        return !this.isGateway && (this.module.actsLikeBatteryPowered() || currentNodeMode === 2 || currentNodeMode === 4)
    };

    handleChangeModuleMode(e: JQuery.UIEventBase) {
        var val = $(e.currentTarget).val();
        if (val == 0) {
            var nodeMode = this.config.findWhere({type: "NODE_MODE"}).get('value');
            var show = this.showInternalSensorConfig(nodeMode);
        } else {
            show = val == 2;
        }

        if (show) {
            this.$('.settings-sensorconfig-internal-sensors-form-group').removeClass('hidden');
        } else {
            this.$('.settings-sensorconfig-internal-sensors-form-group').addClass('hidden');
        }
    }


    render() {
        var panId;

        if (this.config.findWhere({type: "NODE_STICKY_PAN_ID"}).get('value') === 1 || this.isGateway) {
            panId = this.config.findWhere({type: "PAN_ID"}).get('value');
        } else {
            panId = this.lastPanId;
        }
        panId = panId.toString(16).toUpperCase();

        const hasIAQSensors = this.module.get('sensors').some(sensor => sensor.sensor_type === 34);
        
        let moduleOutdoorsValue = false;
        if (hasIAQSensors) {
            const iaqSensor = this.module.get('sensors').find(sensor => sensor.sensor_type === 34);
            if (iaqSensor) {
                const isOutdoorsValue = iaqSensor.is_outdoors;
                moduleOutdoorsValue = isOutdoorsValue === true || Number(isOutdoorsValue) === 1 || String(isOutdoorsValue) === "1";
            }
        }

        this.$el.html(this.template({
            config: this.config,
            isGateway: this.isGateway,
            panId: panId,
            module: this.module,
            con: this.module.getConnector(0),
            moduleNumber: Number(this.module.get('module_number')),
            permissionCollection: this.permissionCollection,
            installId: this.installId,
            currentUser: this.currentUser,
            orgId: this.orgId,
            hasIAQSensors: hasIAQSensors,
            moduleOutdoorsValue: moduleOutdoorsValue
        }));

        // Activate tooltips
        (<any> this.$('[data-toggle="tooltip"]')).tooltip();

        return this;
    };

    hasUpdatedConfig() {
        // TODO: implement properly
        return true
    };

    validate() {
        return true;
    }

    getConfig() {
        var sensorId = this.config.first().get('sensor_id');
        var nodeMode = Number(this.$('.settings-sensorconfig-module-node-mode').val());
        var internalSensors = this.$('.settings-sensorconfig-module-internal-sensor').is(':checked') ? 3 : 0;
        var pollingFreq = (<string> this.$('.settings-sensorconfig-module-polling-freq').val());
        var panId = (<string> this.$('.settings-sensorconfig-module-pan-id').val());
        var stickyPanId = this.$('.settings-sensorconfig-module-sticky-pan-id').is(':checked');
        var globalPollingFreq = (<string> this.$('.settings-sensorconfig-module-global-polling-freq').val());

        // For nodes if stickyPanId is enabled, we should write 0 as pan id into the configuration
        // Otherwise write the panId
        if (!stickyPanId && !this.isGateway) {
            panId = '0';
        }

        // Disable Internal Sensor if Mode is Forced Node or If Node decides Mode and it doesn't act battery powered
        if (nodeMode === 3 || !this.showInternalSensorConfig(nodeMode)) {
            internalSensors = 0;
        }


        return [{
            sensor_id: sensorId,
            type: "NODE_MODE",
            value: nodeMode
        }, {
            sensor_id: sensorId,
            type: "CHARGE_ENABLE",
            value: 1
        }, {
            sensor_id: sensorId,
            type: "INTERNAL_SENSORS",
            value: internalSensors
        }, {
            sensor_id: sensorId,
            type: "POLLING_FREQ",
            value: pollingFreq ? Number(pollingFreq) : 0
        }, {
            sensor_id: sensorId,
            type: "PAN_ID",
            value: panId ? parseInt(panId, 16) : 0
        }, {
            sensor_id: sensorId,
            type: "GATEWAY_GLOBAL_POLLING_FREQ",
            value: globalPollingFreq ? Number(globalPollingFreq) : 0
        }, {
            sensor_id: sensorId,
            type: "NODE_STICKY_PAN_ID",
            value: stickyPanId ? Number(stickyPanId) : 0
        }]
    };

    getModuleLocation() {
        return (<string> this.$('.settings-sensorconfig-module-location').val()).trim();
    };
}



// WEBPACK FOOTER //
// ./srv/public/js/views/settings/sensor_config/ModuleConfigView.ts